import { resolveOffers, resolveOffer } from './resolvers/offer.resolver';

export default [ '$stateProvider', $stateProvider => {
  $stateProvider
    .state('app.admin.offers', {
      url: '/offers',
      component: 'offerList',
      resolve: {
        offers: resolveOffers(1, 20),
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.offer-add', {
      url: '/offers/create',
      component: 'offerSave',
      resolve: {
        title: () => 'Create an offer'
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.offer-edit', {
      url: '/offers/:offer/update?tab',
      component: 'offerSave',
      resolve: {
        title: () => 'Update an offer',
        offer: resolveOffer()
      },
      roles: [ 'manager' ]
    });
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/offer.routes.js